// extracted by mini-css-extract-plugin
export default {"cardsGrid":"CardsPanel_cardsGrid__czM7K","expandedSection":"CardsPanel_expandedSection__vq4WT","cardsColumn":"CardsPanel_cardsColumn__MFiNq"};